import { dcmjsSetString } from '~/domain/dicom/dcmjsAccess';
import type { StructureSet } from './structureset';

export const DERIVED_STRUCTURE_SET_MANUFACTURER =
    'MVision Workspace+ (derived structure set)';

// Marks a set computed only for display in this session: it is never saved, exported or uploaded.
export function markDerivedStructureSet(structureSet: StructureSet): void {
    dcmjsSetString(
        structureSet.dicomStructureSet.datasetWrapper,
        'Manufacturer',
        DERIVED_STRUCTURE_SET_MANUFACTURER
    );
}

export function isDerivedStructureSet(structureSet: {
    readonly dicomStructureSet?: { readonly manufacturer?: string };
}): boolean {
    return (
        structureSet.dicomStructureSet?.manufacturer ===
        DERIVED_STRUCTURE_SET_MANUFACTURER
    );
}
